export const objectMutator = <T>(object: T, mutators: Function[]): T => {
  return mutators.reduce((acc, mutator) => {
    return mutator(acc);
  }, object);
};
